import React from 'react'
import Form from './Form';
import NavbarContact from './NavbarContact';

const contactParent = () => {
  return (
    <>
    <NavbarContact />
    <Form />
    </>
  )
}

export default contactParent
